import { TLCLogger } from "../../../../js/lib/logger";
import { TLCRest } from "../../../../js/lib/rest/REST";
import { LS2PAC_CONSTANTS } from "../../../../js/main/constants";
import { ApplicationData } from "../ApplicationData";
import { EbscoSearchClientManager } from "../ClientManagers/Searching/EbscoSearchClientManager";
import { TitlesSearchClientManager } from '../ClientManagers/Searching/TitlesSearchClientManager';
import { BritannicaSearchClientManager } from '../ClientManagers/Searching/BritannicaSearchClientManager';
import { NewsbankSearchClientManager } from "../ClientManagers/Searching/NewsbankSearchClientManager";
import { GaleSearchClientManager } from "../ClientManagers/Searching/GaleSearchClientManager";
import { WorldbookSearchClientManager } from "../ClientManagers/Searching/WorldbookSearchClientManager";
import { ReservesSearchClientManager } from "../ClientManagers/Searching/ReservesSearchClientManager";
import { Ls2pacResultsView } from "../views/results/Ls2pacResultsView";
import { EbscoResultsView } from "../views/results/EbscoResultsView";
import { BritannicaResultsView } from "../views/results/BritannicaResultsView";
import { NewsbankResultsView } from "../views/results/NewsbankResultsView";
import { GaleResultsView } from "../views/results/GaleResultsView";
import { WorldBookresultsView } from "../views/results/WorldbookResultsView";
import { ReservesResultsView } from "../views/results/ReservesResultsView";
import { Titles_FullDetails } from "../views/details/Titles_FullDetails";
import { Titles_AllCopies } from "../views/details/Titles_AllCopies";
import { Titles_Reviews } from "../views/details/Titles_Reviews";
import { ReviewClientManager } from "../ClientManagers/ReviewsClientManager";
import { Titles_LookInside } from "../views/details/Titles_LookInside";
import { Titles_Related } from "../views/details/Titles_Related";
import { Ebsco_Details } from "../views/details/thirdParty/Ebsco_Details";

export const LS2PacSearchDatabaseManager = function ( $ ) {

	var myDatabases = {},
		currentDatabase = "",
		defaultPageSize = 12,
		configs = [];

	var init = function ( callback ) {
		setupLS2PacDB();
		if( ApplicationData.locationConfiguration.isEbscoEnabled() ) {
			// There is a callback due to the ajax request firing inside the ebsco database setup method
			setupEbscoDB( function () {
				continueSetup( callback );
			} );
		} else {
			continueSetup( callback );
		}

	};

	var continueSetup = function ( callback ) {
		if( ApplicationData.locationConfiguration.isNewsBankEnabled() ) {
			setupNewsbankDB();
		}
		if( ApplicationData.locationConfiguration.isBritannicaEnabled() ) {
			setupBritannicaDB();
		}
		if( ApplicationData.locationConfiguration.isGaleEnabled() ) {
			setupGaleDB();
		}
		if( ApplicationData.locationConfiguration.isWorldBookEnabled() ) {
			setupWorldbookDB();
		}
		if( ApplicationData.locationConfiguration.isReservesEnabled() ) {
			setupReservesDB();
		}
		callback();
	};

	var setupLS2PacDB = function () {
		//setting this config up now because it will always be used
		var ls2pacDBConfig = myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key] = {
			databaseKey:           LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key,
			tabDisplayName:        ApplicationData.language.ls2pacDatabaseTabName,
			isDefault:             true,
			requiresLogin:         false,
			changeLayoutSupported: true,
			hasFacets:             true,
			startsAtZero:          true,
			isBatchable:           true,
			hasSaveSearch:         true,
			supportsAvailability:  true,
			supportsTags:          true,
			supportsReviews:       true,
			supportsSort:          true,
			supportsQuickInfo:     true,
			fullDetailsTemplate:   "tmpl/details/detailsPageView.html",
			sortingData:           {

				sortOptions: [
					{value: 'Relevancy', text: ApplicationData.language.Relevancy},
					{value: 'NewlyAdded', text: ApplicationData.language.NewlyAdded},
					{value: 'PubDate', text: ApplicationData.language.PubDate},
					{value: 'Rating', text: ApplicationData.language.Rating},
					{value: 'Author', text: ApplicationData.language.Author},
					{value: 'Title', text: ApplicationData.language.Title},
					{value: 'CallNumber', text: ApplicationData.language.localCallNumber}
				],
				sortKey:     'Relevancy'
			},
			detailViews:           [
				{
					view:            new Titles_FullDetails( {viewName: LS2PAC_CONSTANTS.DetailPages.fullDetails, isDefault: true} ),
					tabText:         ApplicationData.language.details,
					viewName:        LS2PAC_CONSTANTS.DetailPages.fullDetails,
					showForAllTypes: true
				},
				{
					view:            new Titles_AllCopies( {viewName: LS2PAC_CONSTANTS.DetailPages.allCopies} ),
					tabText:         ApplicationData.language.allCopies,
					viewName:        LS2PAC_CONSTANTS.DetailPages.allCopies,
					showForAllTypes: false
				}
			],
			hasAudienceControl:    true,
			requiresSearchTerm:    true
		};

		if( ApplicationData.locationConfiguration.showReviews() ) {
			var reviewsClientManager = new ReviewClientManager( {} );
			ls2pacDBConfig.detailViews.push( {
				view:            new Titles_Reviews( {viewName: LS2PAC_CONSTANTS.DetailPages.reviews} ),
				tabText:         ApplicationData.language.reviews,
				viewName:        LS2PAC_CONSTANTS.DetailPages.reviews,
				showForAllTypes: false
			} );
		}

		if(ApplicationData.locationConfiguration.showRelatedTab()) {
            ls2pacDBConfig.detailViews.push( {
                view:            new Titles_Related( {viewName: LS2PAC_CONSTANTS.DetailPages.related} ),
                tabText:         ApplicationData.language.related,
                viewName:        LS2PAC_CONSTANTS.DetailPages.related,
                showForAllTypes: false
            } );
		}

		if( ApplicationData.locationConfiguration.showMoreInfoView() ) {
			ls2pacDBConfig.detailViews.push( {
				view:            new Titles_LookInside( {viewName: LS2PAC_CONSTANTS.DetailPages.lookInside} ),
				tabText:         ApplicationData.language.lookInside,
				viewName:        LS2PAC_CONSTANTS.DetailPages.lookInside,
				showForAllTypes: false
			} );
		}


		var ls2pacSearchClientManager = new TitlesSearchClientManager( {
			restUrl:               "search",
			pageSize:              defaultPageSize,
			databaseConfig:        ls2pacDBConfig,
			searchDatabaseManager: LS2PacSearchDatabaseManager
		} );
		// var ls2pacSearchResultsView = new Ls2pacResultsView( {
		// 	databaseConfig: ls2pacDBConfig,
		// 	tmpl:           "tmpl/results/ls2pacListView.html",
		// 	errorTmpl:      "tmpl/results/spellingSuggestions.html"} );

		configs.push( myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key] );

		currentDatabase = ls2pacDBConfig.databaseKey;
	};

	var setupEbscoDB = function ( callback ) {
		TLCRest.jsonCall( "ebsco/sorts", {callback: function ( data ) {
			TLCLogger.log( "ebsco", data );
			var sortData = {sortOptions: []};
			$.each( data.sortOptions, function ( index, option ) {
				sortData.sortOptions.push( {
					value: option.id,
					text:  option.name
				} );
				if( index == 0 ) {
					sortData.sortKey = option.id;
				}
			} );
			if( data.success ) {
				var ebscoDBConfig = myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ebsco.key] = {
					databaseKey:           LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ebsco.key,
					tabDisplayName:        ApplicationData.language.ebscoDatabaseTabName,
					isDefault:             false,
					requiresLogin:         true,
					changeLayoutSupported: false,
					hasFacets:             false,
					startsAtZero:          false,
					isBatchable:           false,
					hasSaveSearch:         false,
					supportsAvailability:  false,
					supportsTags:          false,
					supportsReviews:       false,
					supportsSort:          true,
					fullDetailsTemplate:   "tmpl/details/ebsco/detailsPageView.html",
					sortingData:           sortData,
					detailViews:           [
						{
							view:     new Ebsco_Details( {viewName: LS2PAC_CONSTANTS.DetailPages.ebscoDetailsContainer, isDefault: true} ),
							viewName: LS2PAC_CONSTANTS.DetailPages.fullDetails
						}
					],
					hasAudienceControl:    false,
					requiresSearchTerm:    true
				};

				var ebscoSearchClientManager = new EbscoSearchClientManager( {
					restUrl:               "ebsco/search",
					pageSize:              defaultPageSize,
					databaseConfig:        ebscoDBConfig,
					searchDatabaseManager: LS2PacSearchDatabaseManager
				} );

				var ebscoSearchResultsView = new EbscoResultsView( {
					databaseConfig: ebscoDBConfig,
					tmpl:           "tmpl/results/thirdPartyResultsContainer.html",
					errorTmpl:      "tmpl/results/thirdParty/error.html"} );

				configs.push( myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ebsco.key] );
			}
			callback();
		}, error:                                    function () {
			callback();
		}} );

	};

	var setupBritannicaDB = function () {
		var britannicaDBConfig = myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.britannica.key] = {
			databaseKey:           LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.britannica.key,
			tabDisplayName:        ApplicationData.language.britannicaDatabaseTabName,
			isDefault:             false,
			requiresLogin:         true,
			changeLayoutSupported: false,
			hasFacets:             false,
			startsAtZero:          false,
			isBatchable:           false,
			hasSaveSearch:         false,
			supportsAvailability:  false,
			supportsTags:          false,
			supportsReviews:       false,
			supportsSort:          false,
			fullDetailsTemplate:   "tmpl/details/detailsPageView.html",
			sortingData:           [],
			detailViews:           [],
			hasAudienceControl:    false,
			requiresSearchTerm:    true
		};

		var britannicaSearchClientManager = new BritannicaSearchClientManager( {
			restUrl:               "britannica/search",
			pageSize:              defaultPageSize,
			databaseConfig:        britannicaDBConfig,
			searchDatabaseManager: LS2PacSearchDatabaseManager
		} );

		var britannicaSearchResultsView = new BritannicaResultsView( {
			databaseConfig: britannicaDBConfig,
			tmpl:           "tmpl/results/thirdPartyResultsContainer.html",
			errorTmpl:      "tmpl/results/thirdParty/error.html"} );

		configs.push( myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.britannica.key] );
	};

	var setupNewsbankDB = function () {
		var newsbankDBConfig = myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.newsbank.key] = {
			databaseKey:           LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.newsbank.key,
			tabDisplayName:        ApplicationData.language.newsbankDatabaseTabName,
			isDefault:             false,
			requiresLogin:         true,
			changeLayoutSupported: false,
			hasFacets:             false,
			startsAtZero:          false,
			isBatchable:           false,
			hasSaveSearch:         false,
			supportsAvailability:  false,
			supportsTags:          false,
			supportsReviews:       false,
			supportsSort:          true,
			fullDetailsTemplate:   "tmpl/details/newsbank/detailsPageView.html",
			sortingData:           {
				sortOptions: [
					{value: 'Relevance', text: ApplicationData.language.Relevancy},
					{value: 'Newest Date', text: ApplicationData.language.newestDate},
					{value: 'Oldest Date', text: ApplicationData.language.oldestDate}
				],
				sortKey:     'Newest Date'
			},
			detailViews:           [],
			hasAudienceControl:    false,
			requiresSearchTerm:    true
		};

		var newsbankSearchClientManager = new NewsbankSearchClientManager( {
			restUrl:               "newsbank/search",
			pageSize:              defaultPageSize,
			databaseConfig:        newsbankDBConfig,
			searchDatabaseManager: LS2PacSearchDatabaseManager
		} );

		var newsbankSearchResultsView = new NewsbankResultsView( {
			databaseConfig: newsbankDBConfig,
			tmpl:           "tmpl/results/thirdPartyResultsContainer.html",
			errorTmpl:      "tmpl/results/thirdParty/error.html"} );

		configs.push( myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.newsbank.key] );
	};

	var setupGaleDB = function () {
		var galeDBConfig = myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.gale.key] = {
			databaseKey:           LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.gale.key,
			tabDisplayName:        ApplicationData.language.galeDatabaseTabName,
			isDefault:             false,
			requiresLogin:         true,
			changeLayoutSupported: false,
			hasFacets:             false,
			startsAtZero:          false,
			isBatchable:           false,
			hasSaveSearch:         false,
			supportsAvailability:  false,
			supportsTags:          false,
			supportsReviews:       false,
			supportsSort:          false,
			fullDetailsTemplate:   "tmpl/details/detailsPageView.html",
			sortingData:           {},
			detailViews:           [],
			hasAudienceControl:    false,
			requiresSearchTerm:    true
		};

		var galeSearchClientManager = new GaleSearchClientManager( {
			restUrl:               "gale/search",
			pageSize:              defaultPageSize,
			databaseConfig:        galeDBConfig,
			searchDatabaseManager: LS2PacSearchDatabaseManager
		} );

		var galeSearchResultsView = new GaleResultsView( {
			databaseConfig: galeDBConfig,
			tmpl:           "tmpl/results/thirdPartyResultsContainer.html",
			errorTmpl:      "tmpl/results/thirdParty/error.html"} );

		configs.push( myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.gale.key] );
	};

	var setupReservesDB = function () {
		var reservesDBConfig = myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.reserves.key] = {
			databaseKey:           LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.reserves.key,
			tabDisplayName:        ApplicationData.language.academicReserves,
			isDefault:             false,
			requiresLogin:         false,
			changeLayoutSupported: false,
			hasFacets:             false,
			startsAtZero:          false,
			isBatchable:           false,
			hasSaveSearch:         false,
			hideSearchTerm:        true,
			supportsAvailability:  true,
			supportsTags:          false,
			supportsReviews:       true,
			supportsSort:          true,
			fullDetailsTemplate:   "tmpl/details/detailsPageView.html",
			sortingData:           {
				sortOptions: [
					{value: 'Author', text: ApplicationData.language.Author},
					{value: 'Title', text: ApplicationData.language.Title}
				],
				sortKey:     'Title'
			},
			detailViews:           myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key].detailViews,
			hasAudienceControl:    false,
			hasReservesControl:    true,
			searchTermDisabled:    true,
			navId:                 "alternateTabs",
			requiresSearchTerm:    false,
			ignoreUserBranch:      true
		};

		var reservesSearchClientManager = new ReservesSearchClientManager( {
			restUrl:               "reserves/search",
			pageSize:              defaultPageSize,
			databaseConfig:        reservesDBConfig,
			searchDatabaseManager: LS2PacSearchDatabaseManager
		} );

		var reservesSearchResultsView = new ReservesResultsView( {
			databaseConfig: reservesDBConfig,
			tmpl:           "tmpl/results/thirdPartyResultsContainer.html",
			errorTmpl:      "tmpl/results/thirdParty/error.html"} );

		configs.push( myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.reserves.key] );
	};

	var setupWorldbookDB = function () {
		var worldbookDBConfig = myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.worldbook.key] = {
			databaseKey:           LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.worldbook.key,
			tabDisplayName:        ApplicationData.language.worldbookDatabaseTabName,
			isDefault:             false,
			requiresLogin:         true,
			changeLayoutSupported: false,
			hasFacets:             false,
			startsAtZero:          false,
			isBatchable:           false,
			hasSaveSearch:         false,
			supportsAvailability:  false,
			supportsTags:          false,
			supportsReviews:       false,
			supportsSort:          false,
			fullDetailsTemplate:   "tmpl/details/detailsPageView.html",
			sortingData:           {},
			detailViews:           [],
			hasAudienceControl:    false,
			requiresSearchTerm:    true,
			hasWorldBookControl:   true
		};

		var worldbookSearchClientManager = new WorldbookSearchClientManager( {
			restUrl:               "worldbook/search",
			pageSize:              15,
			databaseConfig:        worldbookDBConfig,
			searchDatabaseManager: LS2PacSearchDatabaseManager
		} );

		var worldbookSearchResultsView = new WorldBookresultsView( {
			databaseConfig: worldbookDBConfig,
			tmpl:           "tmpl/results/thirdPartyResultsContainer.html",
			errorTmpl:      "tmpl/results/thirdParty/error.html"} );

		configs.push( myDatabases[LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.worldbook.key] );
	};


	return {
		setupSearchDatabases:     function ( callback ) {
			init( callback );
		},
		getDatabaseConfigs:       function () {
			return configs;
		},
		getDatabaseConfig: function(databaseKey) {
			return myDatabases[databaseKey];
		},
		getCurrentDatabaseConfig: function () {
			TLCLogger.log( "getCurrentDatabaseConfig", myDatabases, currentDatabase );
			return myDatabases[currentDatabase];
		},
		getCurrentDatabaseKey:    function () {
			return currentDatabase;
		},
		setCurrentDatabaseKey:    function ( databaseKey ) {//LS2PAC_CONSTANTS.Ids.SearchPage.Tabs.ls2pac.key
			//dont let them set something that isnt right
			if( !myDatabases[databaseKey] ) {
				return;
			}
			currentDatabase = databaseKey;
		},
		isCurrentDatabase:        function ( databaseKey ) {
			return (databaseKey == currentDatabase);
		}
	};


}( jQuery );